import VuetifyToast from './toast/index'
import Vue from 'vue';

Vue.use(VuetifyToast, {
	property: '$toast'
})